import { Modal, message, Select, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { putRequest } from "../../service";
import { getChangedFields } from "../../utils/getChangedFields";

const RELATIONSHIP_OPTIONS = [
  { value: "wife", label: "Wife" },
  { value: "husband", label: "Husband" }, 
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
  { value: "brother", label: "Brother" },
  { value: "sister", label: "Sister" },
  { value: "child", label: "Child" },
  { value: "uncle", label: "Uncle" },
];

const DependentsEdit = (props) => {
  const { open, onRequestClose, employee } = props;
  const [form, setForm] = useState({
    relationship_type: "",
    emergency_lastName: "",
    emergency_firstName: "",
    emergency_contact: "",
    remarks: ""
  });
  const originalFormRef = useRef({});

  useEffect(() => {
    if (employee) {
      const initialData = {
        relationship_type: employee.relationship_type || "",
        emergency_lastName: employee.emergency_lastName || "",
        emergency_firstName: employee.emergency_firstName || "",
        emergency_contact: employee.emergency_contact || "",
        remarks: employee.remarks || ""
      };
      setForm(initialData);
      originalFormRef.current = initialData;
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectChange = (value, name) => {
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = getChangedFields(originalFormRef.current, form);
      if (Object.keys(payload).length === 0) {
        message.info("No changes to update");
        return;
      }
      const response = await putRequest(`/api/employees?employeeId=${employee._id}`, payload);
      if (response.message === 'Employee updated successfully (some related data could not be loaded)') {
        message.success('Employee updated successfully')
        onRequestClose();
      }
      else {
        message.error(response.message || "Employee not updated")
      }
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };

  return (
    <Modal
      title="Dependents Information"
      open={open}
      onCancel={onRequestClose}
      footer={null}
      width={800}
    >
      <div className="flex items-start justify-between bg-white h-[55vh] overflow-auto">
        <div className="bg-form-bg w-full rounded-md px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col gap-1">
              <label htmlFor="relationship_type" className="text-md">
                Relationship <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <Select
                className="w-full"
                options={RELATIONSHIP_OPTIONS}
                value={form.relationship_type}
                onChange={(value) => handleSelectChange(value, "relationship_type")}
                placeholder="Select option"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="emergency_lastName" className="text-md">
                Last Name <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="emergency_lastName"
                placeholder="Last Name"
                onChange={handleChange}
                value={form.emergency_lastName}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="emergency_firstName" className="text-md">
                First Name <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="emergency_firstName"
                placeholder="First Name"
                onChange={handleChange}
                value={form.emergency_firstName}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="emergency_contact" className="text-md">
                Contact No
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="emergency_contact"
                placeholder="Contact No"
                onChange={handleChange}
                value={form.emergency_contact}
              />
            </div>

            <div className="flex flex-col gap-1 col-span-2">
              <label htmlFor="remarks" className="text-md">
                Remarks
              </label>
              <textarea
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                rows="3"
                placeholder="Enter any remarks..."
                name="remarks"
                onChange={handleChange}
                value={form.remarks}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onRequestClose} >Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Update Dependents
        </Button>
      </div>
    </Modal>
  );
};

export default DependentsEdit;
